// What a draft is called in a list: its title, else the host's own words. A brief built by the
// wizard starts with the shape's template and ends with "Primary request (…): <the host's line>";
// the host never typed the template, so it is never their draft's name.
export function draftName(post: { title: string | null; brief: string }): string {
  if (post.title) return post.title;
  const own = ownLine(post.brief);
  if (own) return own.slice(0, 80);
  return post.brief.slice(0, 40) || 'Untitled';
}

const ownLine = (text: string) => /Primary request[^:]*:\s*(.+)$/s.exec(text)?.[1]?.trim() ?? '';

/** What the host asked for, in their words: a wizard brief's template is never shown back to them. */
export function hostWords(text: string): string {
  return ownLine(text) || text;
}
